<div class="py-2 px-3" [ngStyle]="{
   backgroundColor: instoreMode ? '#2b2926' : 'white',
   color: instoreMode ? 'white' : 'black' }">
    <!-- [ngClass]="{'mobile-margin-right': instoreMode}" -->
    <!-- Mobile Layout (Stacked) -->
    <div class="row">
        <div class="d-flex flex-column d-lg-none col-10">
            <!-- Location and Shop Name -->
            <div class="d-flex align-items-center mb-1">
                <!-- <img src="assets/icons/current_location_icon.svg" width="16" height="16" class="me-2" style="filter: invert(1);" alt=""> -->
                <img *ngIf="!instoreMode" src="assets/icons/current_location_icon.svg" width="18" class="me-2" alt="">
                <span *ngIf="instoreMode" class="me-2">📍</span>
                <span *ngIf="instoreMode" class="fw-bold me-2" style="white-space: nowrap;">We are at
                </span>
                @if(instoreMode){
                @if (selectedShop.shortName !== null) {
                <span [ngStyle]="{ color:'#ffd000',
                'white-space':'nowrap',
                'overflow': 'hidden',
                'text-overflow':'ellipsis'}" class="op-mode-shop-name">
                    {{selectedShop.shortName}}
                </span>
                }@else {
                    <span [ngStyle]="{ color:'#ffd000',
                'white-space':'nowrap',
                'overflow': 'hidden',
                'text-overflow':'ellipsis'}" class="op-mode-shop-name">
                    {{selectedShop.name}}
                </span>
                }
                }@else{
                <span [ngStyle]="{ color: 'black'}" class="op-mode-shop-name">
                    {{selectedShop.name}}
                </span>
                }
            </div>

            <!-- Prep Time and Delivery Info -->
            <div class="d-flex align-items-center justify-content-between">
                <div class="align-items-center">
                    <!-- <img src="assets/icons/clock_icon.svg" width="16" height="16" class="me-2" style="filter: invert(1);" alt=""> -->
                    @if(instoreMode){
                    <!-- <span class="me-2" style="padding-left: 2px;">⏱</span> -->
                    <span class="text-white-25 me-2">
                        @if(qrInfo.origin == "table-qr"){
                        <span class="me-2" style="padding-left: 2px;">🍽️</span><span class="me-2">Deliver to
                            Table</span>
                        @if (qrInfo.table !== null) {
                        <span style="color: #ffd000;">{{qrInfo.table}}</span>
                        }
                        }@else {
                        <span class="me-2" style="padding-left: 2px;">🛍️</span><span style="margin-left: -4px;">Pickup
                            at Counter</span>
                        }
                    </span>
                    }@else {
                    <img src="assets/icons/clock_icon.svg" width="18" class="me-2" alt="">
                    <span class="text-white-25 me-2" style="margin-left: -4px;">
                        {{deliveryMethod.name}} {{ deliveryDate.label}}
                    </span>
                    <span>{{deliveryDateTime |
                        date:'shortTime'}}</span>

                    }
                </div>


            </div>
        </div>
        @if(!instoreMode){
        <div class="d-flex flex-column d-lg-none col-2">
            <div class="col-auto ms-auto ms-lg-4">
                <button class="btn btn-outline-dark rounded-pill font-secondary px-2 px-sm-3 py-2 ms-sm-0"
                    (click)="navigateToshopList()">
                    <img src="assets/icons/edit_icon.svg" class="me-sm-2 white-icon" alt=""> <span
                        class="d-none d-sm-inline">Change</span>
                </button>
            </div>
        </div>
        }
    </div>
    <!-- Desktop Layout (One Line) -->
    <div class="container container-2 d-none d-lg-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
            <img *ngIf="!instoreMode" src="assets/icons/current_location_icon.svg" width="24" class="me-2" alt="">
            <span *ngIf="instoreMode" class="me-2">📍</span><span *ngIf="instoreMode" class="fw-bold me-2">We are at
            </span>
            @if(instoreMode){
            @if (selectedShop.shortName !== null) {
            <span class="me-5" [ngStyle]="{ color: '#ffd000',fontWeight:'bold' }"> {{selectedShop.shortName}}
            </span>
            }@else {
            <span class="me-5" [ngStyle]="{ color: '#ffd000',fontWeight:'bold' }"> {{selectedShop.name}}
            </span>
            }
            }@else{
            <span class="me-5" [ngStyle]="{ color: 'black' }"> {{selectedShop.name}}
            </span>
            }
            <!-- <img src="assets/icons/clock_icon.svg" width="16" height="16" class="me-2" style="filter: invert(1);" alt=""> -->
            @if(instoreMode){
            @if(qrInfo.origin == "table-qr"){
            <span class="me-2" style="padding-left: 2px;">🍽️</span><span class="me-2">Deliver to Table</span>
            @if (qrInfo.table !== null) {
            <span style="color: #ffd000;">{{qrInfo.table}}</span>
            }
            }@else {
            <span class="me-2" style="padding-left: 2px;">🛍️</span><span>Pickup at Counter</span>
            }
            }@else {
            <img src="assets/icons/clock_icon.svg" width="24" class="me-2" alt="">
            <span class="align-middle">{{deliveryMethod.name}} {{ deliveryDate.label}} </span><span>{{deliveryDateTime |
                date:'shortTime'}}</span>
            <!-- <small class="text-warning fw-bold">{{deliveryMethod.name === 'Instant' ? 'Instant' : deliveryDateTime | date:'shortTime'}}</small> -->
            }
        </div>

        @if(!this.instoreMode){
        <div class="col-auto ms-auto ms-lg-4">
            <button class="btn btn-outline-dark rounded-pill py-2 px-3 ms-lg-5 searchButton"
                (click)="navigateToshopList()">
                <img src="assets/icons/edit_icon.svg" class="me-lg-2 white-icon" alt="" style="width: 20px;"> <span
                    class="align-middle d-lg-inline font-secondary">Change</span>
            </button>
            <!-- <button class="btn btn-outline-dark rounded-pill font-secondary px-2 px-sm-3 py-2 ms-2 ms-sm-0"
                style="margin-right: 2px;" (click)="navigateToshopList()">
                <img src="assets/icons/edit_icon.svg" class="me-sm-2 white-icon" alt=""> <span
                    class="align-middle d-lg-inline">Change</span>
            </button> -->
        </div>
        }
    </div>
</div>